'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Global error occurred:', error);
    const storedTheme = window.localStorage.getItem('alpha-5-theme');
    const dark =
      storedTheme === 'dark' ||
      (storedTheme !== 'light' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    document.documentElement.classList.toggle('dark', dark);
    document.documentElement.classList.toggle('light', !dark);
  }, [error]);

  return (
    <html lang="en" suppressHydrationWarning>
      <body style={{ margin: 0, fontFamily: 'system-ui, sans-serif' }}>
        <style>{`
          body { background: rgb(246 246 246); color: rgb(17 17 17); }
          html.dark body { background: rgb(24 25 28); color: rgb(242 243 245); }
          html.dark .global-error-card {
            background: rgb(35 39 42) !important;
            border-color: rgb(78 80 88) !important;
          }
        `}</style>
        <main
          style={{
            minHeight: '100vh',
            padding: '24px',
            display: 'grid',
            placeItems: 'center',
          }}
        >
          <section
            className="global-error-card"
            style={{
              width: 'min(100%, 640px)',
              padding: '32px',
              border: '1px solid rgb(215 217 220)',
              borderRadius: '16px',
              background: 'rgb(255 255 255)',
              textAlign: 'center',
              boxSizing: 'border-box',
            }}
          >
            <h1>Something Went Wrong</h1>
            <p>Please refresh the page or contact support if the problem persists.</p>
            <button
              type="button"
              onClick={reset}
              style={{
                minHeight: '44px',
                marginTop: '16px',
                padding: '10px 20px',
                border: 0,
                borderRadius: '9999px',
                background: 'rgb(88 101 242)',
                color: 'rgb(255 255 255)',
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              Try Again
            </button>
          </section>
        </main>
      </body>
    </html>
  );
}
